import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

// axios.defaults.withCredentials = true

// export const refreshTokenSlice = createAsyncThunk(
//     'refreshToken',
//     async (li, thunkAPI) => {
//       try{
//         const request = axios.post(
//           `${process.env.REACT_APP_BACKEND_URL}/api/token/refresh/`,
//           {'refresh': 'fillin'}
//         )
//         return request
//       }
//       catch (error){
//         return thunkAPI.rejectWithValue({ error: error.message })
//       }
//     }
//   )

export const setLoginStatusSlice = createAsyncThunk(
    'loginCheck',
    async (li: any, thunkAPI) => {
      try {
        // const request = await axios.get(
        //   //This will have to be dockerized eventually, as nginx in production will server this from /back
        //   process.env.REACT_APP_BACKEND_URL +
        //   '/api/isloggedin', {withCredentials:true}
        // )
        // return request.data

        return li
        // return true
      } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message })
      }
    }
  )

export const selectLoginSlice = (state: any) => state.loginSlice
  
  const loginSlice = createSlice({
    name: 'loginCheck',
    initialState: {
      logged_in: false,
    },
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(setLoginStatusSlice.fulfilled, (state, { payload }) => {
        state.logged_in = payload
        // state.loading = 'loaded'
      })
    },
  })

  
export const logoutSlice = createAsyncThunk(
    'logout',
    async (li, thunkAPI) => {
      try {
        const request = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/userlogout`,
          {'refresh_token': 'fillin'}
        )
        return request.data
        // return true
      } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message })
      }
    }
  )

export default loginSlice